export default __webpack_public_path__ + "static/media/ecom.5561589c.PNG";